import { render } from "./DataFlow.vue?vue&type=template&id=3d854424"
import script from "./DataFlow.vue?vue&type=script&lang=js"
export * from "./DataFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__